import React, { ComponentType } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { checkIsFilmmakersProfile } from "shared-auth";
import { CommonErrorPopup } from "component-library";
import { useTranslation } from "i18n";
import { VIEW_PIN_PATTERN } from "app/config/routes";

interface IComponentProps {
  nonRestrictedPaths?: string[];
}

export default function withPathsFilmmakersAccessRestriction<
  T extends IComponentProps,
>(nonRestrictedPaths?: string[]) {
  return function (WrappedComponent: ComponentType<T>) {
    return (props: T) => {
      const { t } = useTranslation();
      const navigate = useNavigate();
      const location = useLocation();
      const isFilmmakerProfile = checkIsFilmmakersProfile();
      const isViewPinPage = Boolean(
        window.location.pathname.match(VIEW_PIN_PATTERN)
      );

      if (
        isFilmmakerProfile &&
        !isViewPinPage &&
        !nonRestrictedPaths?.includes(location.pathname)
      ) {
        return (
          <CommonErrorPopup
            errorStatusCode={403}
            popupProps={{
              close: () => navigate(-1),
            }}
            alertMessageProps={{
              buttons: [
                {
                  name: t("common:button.label.close"),
                  type: "primary",
                  click: () => navigate(-1),
                },
              ],
            }}
          />
        );
      }

      return <WrappedComponent {...props} />;
    };
  };
}
